import { render, staticRenderFns } from "./CancellationReasonStats.vue?vue&type=template&id=6d20d142&"
import script from "./CancellationReasonStats.vue?vue&type=script&lang=js&"
export * from "./CancellationReasonStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports